import React, { useEffect, useState } from 'react';
import { FiUser, FiHome, FiMail, FiUpload, FiArrowRight, FiX, FiAward, FiCheck } from 'react-icons/fi';
import logo from './logo.png';
import { doc, getDoc } from 'firebase/firestore';
import app, { db } from './firebase';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function RegisterPage() {
  const [userData, setUserData] = useState({
    mobile: "",
    uid: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth(app);
  
  const fetchExistingDetails = async (uid) => {
    try {
      const collectionsToCheck = [
        "scheme1_request",
        "scheme2_request",
        "scheme1_payments",
        "scheme2_payments",
        "users"
      ];

      for (const col of collectionsToCheck) {
        const docRef = doc(db, col, uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          // Check if document has useful address/user details
          if (data.name || data.email || data.house || data.town || data.district || data.state || data.pin || data.houseName || data.place || data.pincode) {
            setFormData(prev => ({
              ...prev,
              name: data.name && data.name !== "N/A" ? data.name : prev.name,
              email: data.email && data.email !== "N/A" ? data.email : prev.email,
              houseName: data.house || data.houseName || prev.houseName,
              town: data.town || data.place || data.town || prev.town,
              landmark: data.landmark || prev.landmark,
              district: data.district || prev.district,
              state: data.state || prev.state,
              pincode: data.pin || data.pincode || prev.pincode,
              idFront: data.id_front || prev.idFront,
              idBack: data.id_back || prev.idBack,
            }));
            
            setPreviews({
              idFront: data.id_front || null,
              idBack: data.id_back || null,
            });
            break;
          }
        }
      }
    } catch (err) {
      console.error("Error fetching existing details:", err);
    }
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserData({
          mobile: user.phoneNumber,
          uid: user.uid,
        });
        fetchExistingDetails(user.uid);
      }
    });
  }, [auth]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    houseName: "",
    town: "",
    landmark: "",
    district: "",
    state: "",
    pincode: "",
    scheme: "gold",
    idFront: null,
    idBack: null,
    amount: 0,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const schemeParam = params.get('scheme');
    if (schemeParam && (schemeParam === 'scheme1' || schemeParam === 'scheme2')) {
      setFormData((prev) => ({
        ...prev,
        scheme: schemeParam,
      }));
    }
  }, [location.search]);

  const [previews, setPreviews] = useState({
    idFront: null,
    idBack: null,
  });

  const [showSchemePopup, setShowSchemePopup] = useState(false);
  const [schemeDetails, setSchemeDetails] = useState([]);
  // ===================== Fetch scheme data ===================== //
  const fetchSchemeData = async () => {
    try {
      const docRef = doc(db, "schemes", "schemes");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setSchemeDetails(data|| []);
      } else {
        // setError("No scheme data found");
      }
    } catch (err) {
      console.error("Error fetching scheme data:", err);
      // setError("Failed to load scheme data");
    }
  }
  useEffect(() => {
    fetchSchemeData();
  }, []);
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        [field]: file,
      });

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews({
          ...previews,
          [field]: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (field) => {
    setFormData({
      ...formData,
      [field]: null,
    });
    setPreviews({
      ...previews,
      [field]: null,
    });
  };

  // ============= Scheme info ================ //
  const handleSchemeInfo = () => {
    setShowSchemePopup(true);
  };

  // ===================== check user exists or not in schemes ===================== //
  const [loading, setLoading] = useState(false);
  const checkUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!userData.uid || !userData.mobile) {
      toast.error("Failed to register. Please try again.");
      setLoading(false);
      return;
    }
    const docRef = doc(db, formData.scheme + "_active_scheme", userData.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      toast.warning("You have already joined this scheme");
      setLoading(false);
    } else {
      const reqRef = doc(db, formData.scheme + "_request", userData.uid);
      const reqDoc = await getDoc(reqRef);
      if (reqDoc.exists()) {
        toast.warning(`You have already applied for ${formData.scheme === "scheme1" ? "Scheme 1" : "Scheme 2"} scheme. Please wait for approval or contact Chirayil Gold And Diamonds.`);
        setLoading(false);
      } else {
        uploadData(userData.uid);
      }
    }
  };

  // ===================== Upload images ===================== //
   const uploadData = async (docId) => {
    const storage = getStorage();
     try {
       let frontUrl = formData.idFront;
       let backUrl = formData.idBack;

       const uploadPromises = [];

       if (formData.idFront instanceof File) {
         const frontRef = ref(storage, `Images/${docId}/id_front`);
         uploadPromises.push(
           uploadBytes(frontRef, formData.idFront)
             .then(() => getDownloadURL(frontRef))
             .then((url) => { frontUrl = url; })
         );
       }

       if (formData.idBack instanceof File) {
         const backRef = ref(storage, `Images/${docId}/id_back`);
         uploadPromises.push(
           uploadBytes(backRef, formData.idBack)
             .then(() => getDownloadURL(backRef))
             .then((url) => { backUrl = url; })
         );
       }

       if (uploadPromises.length > 0) {
         await Promise.all(uploadPromises);
       }
       // =============== Calling function to add user to scheme =============== //
       const userDetails = {
         mobile: userData.mobile,
         name: formData.name,
         uid: userData.uid,
         scheme: 0,
       };
       const schemeData = {
         district: formData.district,
         email: formData.email,
         house: formData.houseName,
         id_back: backUrl,
         id_front: frontUrl,
         landmark: formData.landmark,
         mobile: userData.mobile,
         name: formData.name,
         pin: formData.pincode,
         place: formData.town,
         req_time: new Date(),
         scheme: formData.scheme,
         scheme_amount: 0,
         state: formData.state,
         status: "requested",
         town: formData.town,
         uid: userData.uid,
         amount: formData.amount,
       };
       const functions = getFunctions(app, "asia-south1");
       const callable = httpsCallable(functions, "createUserAccount");
       try {
         const res = await callable({ userData:{...userDetails}, schemeData, admin: false });
          if (res.data.code === 200) {
            setLoading(false);
            toast.success("Registration successful!");
            navigate(`/passbook?scheme=${formData.scheme}`);
          } else {
           setLoading(false);
           toast.error(res.data.message);
         }
       } catch (error) {
         setLoading(false);
         toast.error(error.message);
       }
     } catch (error) {
       toast.error("Image upload failed");
       setLoading(false);
     }
   };
 
  return (
    <div className="min-h-screen bg-gradient-to-br from-luxury-cream via-white to-gold-50/20 px-4 sm:px-6 lg:px-8 py-28 relative">
      {/* Decorative Blur Backgrounds */}
      <div className="absolute top-1/4 left-1/10 w-80 h-80 bg-gold-200/10 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 right-1/10 w-80 h-80 bg-gold-300/15 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="max-w-4xl mx-auto glass-card rounded-2xl overflow-hidden border border-gold-200/20 shadow-xl relative z-10">
        
        {/* Header Banner */}
        <div className="bg-gradient-to-r from-gold-600 via-gold-500 to-gold-700 p-6 sm:p-8 text-white relative">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-gold-400/25 via-transparent to-transparent pointer-events-none"></div>
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="flex items-center">
              <img src={logo} className="h-10 w-10 object-contain brightness-0 invert" alt="Chirayil Crest Logo" />
              <h1 className="ml-3 text-2xl font-serif font-bold tracking-widest text-white">
                CHIRAYIL
              </h1>
            </div>
            <div className="mt-6 text-left">
              <h2 className="text-xl font-serif font-bold text-white tracking-wide">
                Gold Scheme Registration
              </h2>
              <p className="text-xs text-gold-100/90 font-light mt-1 uppercase tracking-wider">
                Please provide your details below to activate your gold savings plan
              </p>
            </div>
          </div>
        </div>

        {/* Form Body */}
        <div className="p-6 sm:p-10 bg-white/60">
          <div className="max-w-7xl mx-auto">
            <form className="space-y-6" onSubmit={checkUser}>
              
              {/* Full Name */}
              <div className="space-y-2">
                <label htmlFor="name" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                  Full Name
                </label>
                <div className="relative rounded-xl">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <FiUser className="h-5 w-5 text-gold-500" />
                  </div>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="py-3.5 pl-11 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="Enter your full name"
                  />
                </div>
              </div>

              {/* House Number and Email */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label htmlFor="houseName" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    House/Building No
                  </label>
                  <div className="relative rounded-xl">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                      <FiHome className="h-5 w-5 text-gold-500" />
                    </div>
                    <input
                      id="houseName"
                      name="houseName"
                      type="text"
                      required
                      value={formData.houseName}
                      onChange={handleChange}
                      className="py-3.5 pl-11 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                      placeholder="House Name / No."
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Email Address
                  </label>
                  <div className="relative rounded-xl">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                      <FiMail className="h-5 w-5 text-gold-500" />
                    </div>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="py-3.5 pl-11 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
              </div>

              {/* Town & Landmark */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label htmlFor="town" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Town/City
                  </label>
                  <input
                    id="town"
                    name="town"
                    type="text"
                    required
                    value={formData.town}
                    onChange={handleChange}
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="Town or City"
                  />
                </div>

                <div className="space-y-2">
                  <label htmlFor="landmark" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Landmark
                  </label>
                  <input
                    id="landmark"
                    name="landmark"
                    type="text"
                    value={formData.landmark}
                    onChange={handleChange}
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="Nearby landmark (optional)"
                  />
                </div>
              </div>

              {/* District, State, Pincode */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <div className="space-y-2">
                  <label htmlFor="district" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    District
                  </label>
                  <input
                    id="district"
                    name="district"
                    type="text"
                    required
                    value={formData.district}
                    onChange={handleChange}
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="District"
                  />
                </div>

                <div className="space-y-2">
                  <label htmlFor="state" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    State
                  </label>
                  <input
                    id="state"
                    name="state"
                    type="text"
                    required
                    value={formData.state}
                    onChange={handleChange}
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="State"
                  />
                </div>

                <div className="space-y-2">
                  <label htmlFor="pincode" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Pincode
                  </label>
                  <input
                    id="pincode"
                    name="pincode"
                    type="text"
                    required
                    value={formData.pincode}
                    onChange={handleChange}
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                    placeholder="Pincode"
                  />
                </div>
              </div>

              {/* Scheme Selector */}
              <div className="space-y-4">
                <div className="space-y-2">
                  <label htmlFor="scheme" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                    Select Scheme
                  </label>
                  <select
                    id="scheme"
                    name="scheme"
                    value={formData.scheme}
                    onChange={handleChange}
                    required
                    className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200 text-luxury-charcoal"
                  >
                    <option value="">Select Scheme Option</option>
                    <option value="scheme1">Scheme 1 - Plan A</option>
                    <option value="scheme2">Scheme 2 - Plan B</option>
                  </select>
                </div>

                {formData.scheme && (
                  <div
                    className="inline-flex items-center gap-1.5 text-gold-600 hover:text-gold-700 font-bold text-xs uppercase tracking-wider cursor-pointer transition-colors duration-200"
                    onClick={handleSchemeInfo}
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    View Scheme Comparison Details
                  </div>
                )}

                {formData?.scheme === "scheme1" && (
                  <div className="space-y-2 animate-fade-in">
                    <label htmlFor="amount" className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                      Initial Payment Amount
                    </label>
                    <input
                      id="amount"
                      name="amount"
                      type="number"
                      required
                      value={formData.amount}
                      onChange={handleChange}
                      className="py-3.5 px-4 block w-full bg-white border border-gold-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-gold-500/20 focus:border-gold-500 text-sm font-semibold transition-all shadow-sm hover:border-gold-200"
                      placeholder="Enter amount (₹)"
                    />
                  </div>
                )}
              </div>

              {/* ID Proof upload */}
              <div className="space-y-2">
                <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">
                  ID Proof Verification (Image Upload)
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  
                  {/* Front Upload */}
                  <div className="space-y-2">
                    <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Front Side Card</span>
                    <div className="relative">
                      <input
                        id="idFront"
                        name="idFront"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "idFront")}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                      />
                      {previews.idFront ? (
                        <div className="relative rounded-xl overflow-hidden border border-gold-200/50">
                          <img
                            src={previews.idFront}
                            alt="ID Front Preview"
                            className="w-full h-40 object-contain bg-gold-50/10 p-2"
                          />
                          <button
                            type="button"
                            onClick={() => removeImage("idFront")}
                            className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm rounded-full p-1.5 shadow hover:bg-white text-gray-600 transition-colors z-20"
                          >
                            <FiX className="h-4 w-4 text-red-600" />
                          </button>
                        </div>
                      ) : (
                        <div className="flex flex-col items-center justify-center py-6 px-4 border-2 border-dashed border-gold-200/40 rounded-xl hover:border-gold-500 bg-gold-50/10 hover:bg-gold-50/20 transition-all text-center">
                          <FiUpload className="h-6 w-6 text-gold-500 mb-1" />
                          <span className="text-xs font-semibold text-gold-700">
                            {formData.idFront ? formData.idFront.name : "Upload Front Image"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Back Upload */}
                  <div className="space-y-2">
                    <span className="block text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Back Side Card</span>
                    <div className="relative">
                      <input
                        id="idBack"
                        name="idBack"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "idBack")}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                      />
                      {previews.idBack ? (
                        <div className="relative rounded-xl overflow-hidden border border-gold-200/50">
                          <img
                            src={previews.idBack}
                            alt="ID Back Preview"
                            className="w-full h-40 object-contain bg-gold-50/10 p-2"
                          />
                          <button
                            type="button"
                            onClick={() => removeImage("idBack")}
                            className="absolute top-2 right-2 bg-white/90 backdrop-blur-sm rounded-full p-1.5 shadow hover:bg-white text-gray-600 transition-colors z-20"
                          >
                            <FiX className="h-4 w-4 text-red-600" />
                          </button>
                        </div>
                      ) : (
                        <div className="flex flex-col items-center justify-center py-6 px-4 border-2 border-dashed border-gold-200/40 rounded-xl hover:border-gold-500 bg-gold-50/10 hover:bg-gold-50/20 transition-all text-center">
                          <FiUpload className="h-6 w-6 text-gold-500 mb-1" />
                          <span className="text-xs font-semibold text-gold-700">
                            {formData.idBack ? formData.idBack.name : "Upload Back Image"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>

              {/* T&C check */}
              <div className="flex items-start gap-2.5 pt-2 text-xs text-luxury-charcoal font-medium">
                <input
                  type="checkbox"
                  required
                  id="agreeCheckbox"
                  className="rounded border-gold-300 text-gold-600 focus:ring-gold-500/30 mt-0.5"
                />
                <label htmlFor="agreeCheckbox" className="leading-relaxed">
                  I agree to the{" "}
                  <a href="/terms-and-conditions" className="text-gold-600 hover:text-gold-700 underline font-semibold">
                    terms and conditions
                  </a>
                  {" "}and{" "}
                  <a href="/privacy-policy" className="text-gold-600 hover:text-gold-700 underline font-semibold">
                    privacy policy
                  </a>
                  {" "}governing the savings scheme.
                </label>
              </div>

              {/* Submit */}
              <div className="pt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full flex justify-center items-center gap-2 py-3.5 px-6 rounded-xl text-xs font-bold uppercase tracking-widest text-white transition-all shadow-md ${
                    loading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-gold-600 via-gold-500 to-gold-700 hover:shadow-lg hover:shadow-gold-500/10 hover:scale-[1.01] active:scale-[0.99]"
                  }`}
                >
                  {loading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                      <span>Processing Registration...</span>
                    </>
                  ) : (
                    <>
                      <span>Complete Registration</span>
                      <FiArrowRight className="w-4 h-4" />
                    </>
                  )}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

      {/* T&C / Schemes Info Popup dialog */}
      {showSchemePopup && (
        <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
          <div 
            className="absolute inset-0 bg-luxury-black/75 backdrop-blur-md transition-opacity duration-300"
            onClick={() => setShowSchemePopup(false)}
          />
          
          <div className="relative glass-panel bg-white/95 max-w-xl w-full max-h-[80vh] overflow-y-auto shadow-2xl rounded-2xl border border-gold-200/30 overflow-hidden transform transition-all duration-300 animate-scale-in">
            <div className="bg-gradient-to-r from-gold-600 via-gold-500 to-gold-700 px-6 py-5 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="bg-white/20 p-2 rounded-lg mr-3">
                    <FiAward className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-serif font-bold text-white tracking-wide">
                      Investment Schemes
                    </h2>
                    <p className="text-gold-100/90 text-xs font-light tracking-wide uppercase">
                      Select your preferred investment plan
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setShowSchemePopup(false)}
                  className="bg-white/20 hover:bg-white/30 p-1.5 rounded-lg transition-colors duration-200"
                >
                  <FiX className="w-4 h-4 text-white" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              
              {/* Scheme 1 details */}
              <div className="bg-gold-50/30 border border-gold-200/20 rounded-xl overflow-hidden">
                <div className="bg-gold-600 px-4 py-2.5 text-white">
                  <h3 className="text-sm font-bold uppercase tracking-wider">Scheme 1 - Plan A Details</h3>
                </div>

                <div className="p-4 space-y-2.5">
                  {schemeDetails &&
                    schemeDetails.scheme1_details &&
                    schemeDetails.scheme1_details.map((detail, index) => (
                      <div key={index} className="flex items-start gap-2.5 text-xs text-luxury-charcoal">
                        <FiCheck className="w-3.5 h-3.5 text-gold-600 mt-0.5 flex-shrink-0" />
                        <span className="font-medium">{detail}</span>
                      </div>
                    ))}
                </div>
              </div>

              {/* Scheme 2 details */}
              <div className="bg-gold-50/30 border border-gold-200/20 rounded-xl overflow-hidden">
                <div className="bg-gold-600 px-4 py-2.5 text-white">
                  <h3 className="text-sm font-bold uppercase tracking-wider">Scheme 2 - Plan B Details</h3>
                </div>

                <div className="p-4 space-y-2.5">
                  {schemeDetails &&
                    schemeDetails.scheme2_details &&
                    schemeDetails.scheme2_details.map((detail, index) => (
                      <div key={index} className="flex items-start gap-2.5 text-xs text-luxury-charcoal">
                        <FiCheck className="w-3.5 h-3.5 text-gold-600 mt-0.5 flex-shrink-0" />
                        <span className="font-medium">{detail}</span>
                      </div>
                    ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}